
import { defineComponent } from 'vue';
import TypingCarousel from '@/components/TypingCarousel.vue';

export default defineComponent({
  components: {
    TypingCarousel,
  },
});
